import { render, staticRenderFns } from "./SlotsSimple.vue?vue&type=template&id=06e51d93&scoped=true&"
import script from "./SlotsSimple.vue?vue&type=script&lang=js&"
export * from "./SlotsSimple.vue?vue&type=script&lang=js&"
import style0 from "./SlotsSimple.vue?vue&type=style&index=0&id=06e51d93&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e51d93",
  null
  
)

export default component.exports